import { useListPage } from '@/hooks/use-list-page'

export const useAreaName = (): string => {
  const { prefecture, city, station } = useListPage()

  if (station) return `${station.name}駅周辺`
  if (city) return `${city.name}`
  return `${prefecture.name}`
}
